(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["watany-back-in-stock"] && !Shopify.designMode) return;
  try {
    class WatanyBackInStock extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-bis-form]');
      this.submitButton = this.querySelector('[data-bis-submit]');
      this.status = this.querySelector('[data-bis-status]');
      this.success = this.querySelector('[data-bis-success]');
      this.productElement = this.closest('watany-product');
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.form?.addEventListener('submit', this.handleSubmit);
      this.productElement?.addEventListener('variant:change', this.handleVariantChange);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit);
      this.productElement?.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;
      if (!variant) return;
      this.dataset.variantId = String(variant.id);
      this.hidden = Boolean(variant.available);
      if (!variant.available) this.reset();
    }

    reset() {
      if (this.form) this.form.hidden = false;
      if (this.success) this.success.hidden = true;
      if (this.status) this.status.textContent = '';
    }

    async handleSubmit(event) {
      event.preventDefault();
      const emailInput = this.form?.querySelector('[name="email"]');
      if (!emailInput?.reportValidity()) return;

      this.submitButton.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = '';

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { email: emailInput.value.trim() },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + this.dataset.variantId,
              },
            },
          },
        },
      };

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
            encodeURIComponent(this.dataset.companyId),
          {
            method: 'POST',
            headers: {
              accept: 'application/json',
              'content-type': 'application/json',
              revision: '2026-07-15',
            },
            body: JSON.stringify(payload),
          }
        );

        if (!response.ok) throw new Error('Back-in-stock subscription failed');
        this.form.hidden = true;
        this.success.hidden = false;
      } catch (error) {
        this.status.textContent = this.dataset.errorMessage;
      } finally {
        this.submitButton.disabled = false;
        this.form.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('watany-back-in-stock')) {
    customElements.define('watany-back-in-stock', WatanyBackInStock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watany-menu-drawer"] && !Shopify.designMode) return;
  try {
    class WatanyMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('.watany-menu');
      this.overlay = this.querySelector('[data-menu-overlay]');
      this.closeBtn = this.querySelector('[data-menu-close]');
      this.toggle = document.getElementById('menu-toggle');
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      if (this.toggle) {
        this.toggle.addEventListener('click', () => this.open());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      this.querySelectorAll('.watany-menu a').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });
    }

    open() {
      this.classList.add('is-open');
      if (this.drawer) this.drawer.setAttribute('aria-hidden', 'false');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('watany-menu-open');
      document.addEventListener('keydown', this.onKeydown);
      const first = this.drawer && this.drawer.querySelector('a, button');
      if (first) first.focus();
    }

    close() {
      this.classList.remove('is-open');
      if (this.drawer) this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('watany-menu-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.toggle) {
        this.toggle.setAttribute('aria-expanded', 'false');
        this.toggle.focus();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab' || !this.drawer) return;
      const focusable = this.drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('watany-menu-drawer')) {
    customElements.define('watany-menu-drawer', WatanyMenuDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watany-product-gallery"] && !Shopify.designMode) return;
  try {
    class WatanyGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery]');
      this.dotsWrap = this.querySelector('[data-dots]');
      this.colorIndex = parseInt(this.dataset.colorIndex, 10);
      this.dots = [];
      this.modelEl = this.querySelector('[data-model]');

      this.querySelectorAll('[data-model-toggle]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const media = btn.closest('.watany-pdp__media');
          if (media) this.setModelOpen(media, !media.classList.contains('show-model'));
        });
      });
      this.querySelectorAll('[data-model-close]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          const media = btn.closest('.watany-pdp__media');
          if (media) this.setModelOpen(media, false);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeModelPanels();
      });
      document.addEventListener('click', (event) => {
        if (this.contains(event.target) && event.target.closest('.watany-pdp__media.show-model')) return;
        this.closeModelPanels();
      });

      if (this.track) {
        this.track.addEventListener('scroll', () => this.syncDots(), { passive: true });
      }

      if (!Number.isNaN(this.colorIndex) && this.colorIndex >= 0) {
        const host = this.closest('watany-product');
        if (host) {
          host.addEventListener('variant:change', (event) => {
            const variant = event.detail && event.detail.variant;
            if (variant && variant.options) {
              this.filterByColor(variant.options[this.colorIndex]);
            }
          });
        }
      }

      this.filterByColor(this.dataset.initialColor || '');
    }

    setModelOpen(media, open) {
      media.classList.toggle('show-model', open);
      const toggle = media.querySelector('[data-model-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    closeModelPanels() {
      this.querySelectorAll('.watany-pdp__media.show-model').forEach((media) => {
        this.setModelOpen(media, false);
      });
    }

    filterByColor(color) {
      this.closeModelPanels();
      const medias = Array.from(this.querySelectorAll('.watany-pdp__media'));
      let firstShown = null;
      let shownCount = 0;
      medias.forEach((media) => {
        const raw = (media.dataset.mediaColors || '').replace(/,+$/, '');
        const colors = raw ? raw.split(',') : [];
        const show = !color || colors.length === 0 || colors.indexOf(color) !== -1;
        media.hidden = !show;
        if (show) {
          shownCount += 1;
          if (!firstShown) firstShown = media;
        }
      });
      if (!firstShown) {
        medias.forEach((media) => {
          media.hidden = false;
        });
        firstShown = medias[0];
        shownCount = medias.length;
      }
      medias.forEach((media) => {
        const isLead = media === firstShown;
        if (media.classList.contains('watany-pdp__media--lead') !== isLead) {
          media.classList.toggle('watany-pdp__media--lead', isLead);
        }
      });
      if (this.modelEl && firstShown && this.modelEl.parentElement !== firstShown) {
        firstShown.appendChild(this.modelEl);
      }
      if (this.track) this.track.scrollLeft = 0;
      this.buildDots(shownCount);
    }

    buildDots(count) {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      if (count < 2) {
        this.dotsWrap.style.display = 'none';
        this.dots = [];
        return;
      }
      this.dotsWrap.style.display = '';
      for (let i = 0; i < count; i += 1) {
        const dot = document.createElement('span');
        dot.className = 'watany-pdp__dot';
        if (i === 0) dot.classList.add('is-on');
        this.dotsWrap.appendChild(dot);
      }
      this.dots = Array.from(this.dotsWrap.children);
    }

    syncDots() {
      if (!this.track || !this.dots.length) return;
      const width = this.track.clientWidth || 1;
      const index = Math.round(this.track.scrollLeft / width);
      this.dots.forEach((dot, idx) => dot.classList.toggle('is-on', idx === index));
    }
  }

  if (!customElements.get('watany-gallery')) {
    customElements.define('watany-gallery', WatanyGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watany-quick-add"] && !Shopify.designMode) return;
  try {
    class WatanyQuickAdd extends HTMLElement {
    connectedCallback() {
      this.labelEl =
        this.querySelector('.watany-quick__label') ||
        this.querySelector('.watany-quick__add');
      this.addEventListener('click', (event) => {
        const btn = event.target.closest('button[data-variant-id]');
        if (!btn || btn.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        this.dispatch(Number(btn.dataset.variantId));
      });
      this.onResult = this.onResult.bind(this);
      window.addEventListener('watany:cart-added', this.onResult);
      window.addEventListener('watany:cart-error', this.onResult);
    }

    disconnectedCallback() {
      window.removeEventListener('watany:cart-added', this.onResult);
      window.removeEventListener('watany:cart-error', this.onResult);
    }

    dispatch(variantId) {
      if (!variantId || this.pendingId != null) return;
      this.pendingId = variantId;
      window.dispatchEvent(
        new CustomEvent('watany:cart-add', { detail: { id: variantId, quantity: 1 } })
      );
      clearTimeout(this.safetyTimer);
      this.safetyTimer = setTimeout(() => {
        this.pendingId = null;
      }, 6000);
    }

    onResult(event) {
      if (!event.detail || event.detail.id !== this.pendingId) return;
      clearTimeout(this.safetyTimer);
      this.pendingId = null;
      this.flashLabel(event.type === 'watany:cart-added' ? 'Added ✓' : 'Sold out');
    }

    flashLabel(text) {
      this.classList.add('is-added');
      if (this.labelEl) {
        if (this.savedLabel === undefined) this.savedLabel = this.labelEl.textContent;
        this.labelEl.textContent = text;
      }
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        this.classList.remove('is-added');
        if (this.labelEl && this.savedLabel !== undefined) {
          this.labelEl.textContent = this.savedLabel;
        }
      }, 1800);
    }
  }

  if (!customElements.get('watany-quick-add')) {
    customElements.define('watany-quick-add', WatanyQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["watany-variant-picker"] && !Shopify.designMode) return;
  try {
    class WatanyVariantPicker extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.idInput = this.querySelector('[data-variant-id]');
      this.addEventListener('change', (event) => {
        if (event.target.classList.contains('watany-pdp__opt')) this.onChange();
      });
      this.refreshAvailability();
    }

    get selected() {
      const groups = {};
      this.querySelectorAll('.watany-pdp__opt:checked').forEach((input) => {
        groups[input.dataset.optionIndex] = input.value;
      });
      return Object.keys(groups)
        .sort((a, b) => Number(a) - Number(b))
        .map((key) => groups[key]);
    }

    onChange() {
      let selected = this.selected;
      let variant = this.findVariant(selected);
      if (!variant) {
        const repaired = this.repairSelection(selected);
        if (repaired) {
          selected = repaired;
          this.applySelection(selected);
          variant = this.findVariant(selected);
        }
      }
      this.querySelectorAll('.watany-pdp__opt:checked').forEach((input) => {
        const label = this.querySelector(
          '[data-selected-label="' + input.dataset.optionIndex + '"]'
        );
        if (label) label.textContent = input.value;
      });
      if (variant && this.idInput) this.idInput.value = variant.id;
      this.refreshAvailability();
      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant: variant || null },
        })
      );
    }

    findVariant(selected) {
      return this.variants.find(
        (item) =>
          item.options.length === selected.length &&
          item.options.every((opt, idx) => opt === selected[idx])
      );
    }

    repairSelection(selected) {
      // Find an available variant that keeps the most-recently-changed option
      // fixed and rotates the others. We don't know which option just changed,
      // so prefer one matching the highest-index pinned value (typically Color).
      for (let pinIdx = selected.length - 1; pinIdx >= 0; pinIdx--) {
        const match = this.variants.find(
          (v) => v.available && v.options[pinIdx] === selected[pinIdx]
        );
        if (match) return match.options.slice();
      }
      const anyAvail = this.variants.find((v) => v.available);
      return anyAvail ? anyAvail.options.slice() : null;
    }

    applySelection(values) {
      this.querySelectorAll('.watany-pdp__opt').forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const want = values[idx];
        if (input.value === want) input.checked = true;
      });
    }

    refreshAvailability() {
      const selected = this.selected;
      if (!selected.length) return;
      this.querySelectorAll('.watany-pdp__opt').forEach((input) => {
        const idx = Number(input.dataset.optionIndex);
        const hypo = selected.slice();
        hypo[idx] = input.value;
        const okWithCurrent = this.variants.some(
          (variant) =>
            variant.available &&
            hypo.every((value, i) => variant.options[i] === value)
        );
        const existsAnywhere = this.variants.some(
          (variant) => variant.options[idx] === input.value
        );
        input.disabled = !existsAnywhere && !input.checked;
        const label = input.nextElementSibling;
        if (label) label.classList.toggle('is-unavailable', !okWithCurrent);
      });
    }
  }

  if (!customElements.get('watany-variant-picker')) {
    customElements.define('watany-variant-picker', WatanyVariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
